const contactInformation = {
  emailId: "support@omic.health",
  phoneNo: 9920596642,
};

export default contactInformation;
